import React from 'react';
import Style from './modal.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Modal = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  let windowHeight = window.innerHeight;
  React.useEffect(() => {
    let modal = [];
    modal = document.querySelectorAll(`.${Style.modal}`);
    modal.forEach(obj => {
      obj.style.height = windowHeight + 'px';
    });
  }, [windowHeight]);
  return _jsx(React.Fragment, {
    children: propsArray.className !== '' && _jsx("div", {
      className: `${Style.modal} ${propsArray.className} d-none`,
      css: emotionStyle,
      children: props.children
    })
  });
};

Modal.Header = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  const close = () => {
    let modal = document.querySelectorAll(`.${Style.modal}`);
    modal.forEach(obj => {
      obj.classList.add('d-none');
    });
  };

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsxs("div", {
      onClick: close,
      className: `${Style.header}`,
      css: emotionStyle,
      children: [props.children, _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        children: _jsx("path", {
          stroke: "#28293D",
          d: "m1 1 6 5.999L13 1 1 13l6-6 6 6"
        })
      })]
    }), propsArray.className !== '' && _jsxs("div", {
      onClick: close,
      className: `${Style.header} ${propsArray.className}`,
      css: emotionStyle,
      children: [props.children, _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 14",
        children: _jsx("path", {
          stroke: "#28293D",
          d: "m1 1 6 5.999L13 1 1 13l6-6 6 6"
        })
      })]
    })]
  });
};

Modal.Wrapper = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.size = Style[props.size === undefined ? 'xs' : props.size];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("div", {
      className: `${Style.wrapper} ${propsArray.size}`,
      css: emotionStyle,
      children: props.children
    }), propsArray.className !== '' && _jsx("div", {
      className: `${Style.wrapper} ${propsArray.size} ${propsArray.className}`,
      css: emotionStyle,
      children: props.children
    })]
  });
};

export default Modal;